import fetchPosts from '../fetch/fetch-posts'

export default function pagination (archive) {
    jQuery(archive).on('click', '.mtt-pagination__toggle', event => {
        fetchPosts(archive, event.currentTarget)
    })
}